import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { AtSign, Loader2 } from "lucide-react";

const clean = (v) => v.toLowerCase().replace(/^@/, "").replace(/[^a-z0-9-]/g, "").slice(0, 30);

export default function HandleEditor() {
  const [current, setCurrent] = useState("");
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/filmmaker/handle").then((r) => { setCurrent(r.data.handle); setValue(r.data.handle); }).catch(() => {});
  }, []);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.patch("/filmmaker/handle", { handle: value });
      setCurrent(data.handle);
      setValue(data.handle);
      toast.success("Profile link updated");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Could not update handle");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mb-6 bg-surface border border-white/10 rounded-2xl p-6 sm:p-8" data-testid="handle-panel">
      <Label>Profile link</Label>
      <p className="text-xs text-foreground/55 mt-1 mb-3">Your unique, shareable Cinevoya address. Changing it breaks the old link.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="flex-1 min-w-0 flex items-center h-11 rounded-md bg-ink border border-white/10 px-3 focus-within:border-terracotta/60 transition-colors">
          <span className="text-foreground/45 text-sm font-mono truncate shrink max-w-[45%] hidden sm:inline">{window.location.host}/</span>
          <AtSign className="w-4 h-4 text-gold shrink-0" />
          <input
            value={value}
            onChange={(e) => setValue(clean(e.target.value))}
            className="flex-1 min-w-0 bg-transparent outline-none text-sm font-mono"
            placeholder="your-name"
            data-testid="handle-input"
          />
        </div>
        <Button
          type="button"
          onClick={save}
          disabled={saving || !value || value === current}
          className="bg-terracotta hover:bg-ember text-white h-11"
          data-testid="handle-save-btn"
        >
          {saving && <Loader2 className="w-4 h-4 animate-spin" />} Save link
        </Button>
      </div>
    </div>
  );
}
